import React from 'react';

const AWS_EC2_Instance_Types = () => {
  return (
    <div>
      <h1>AWS_EC2_Instance_Types</h1>
      <p>This is the AWS_EC2_Instance_Types component.</p>
    </div>
  );
};

export default AWS_EC2_Instance_Types;
